import { render, staticRenderFns } from "./upload-photo.vue?vue&type=template&id=3ed175fc"
import script from "./upload-photo.vue?vue&type=script&lang=js"
export * from "./upload-photo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports